import { render, staticRenderFns } from "./BrandProductPriceToolbar.vue?vue&type=template&id=52d6e947&scoped=true&"
import script from "./BrandProductPriceToolbar.vue?vue&type=script&lang=js&"
export * from "./BrandProductPriceToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BrandProductPriceToolbar.vue?vue&type=style&index=0&id=52d6e947&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6e947",
  null
  
)

export default component.exports